import { extend } from "flarum/common/extend";
import app from "flarum/app";
import LinkButton from "flarum/common/components/LinkButton";
import UserPage from "flarum/forum/components/UserPage";
import ProfessionalAchievementsPane from "../panes/PersonalAdvcommentsPane";

export default function () {
  app.routes["tolyod-advcomments-personal-advcomments-view-profile"] = {
    path: "/user_advcomments/:id",
    component: ProfessionalAchievementsPane,
  };
  extend(UserPage.prototype, "navItems", function (items) {
    const href = app.route(
      "tolyod-advcomments-personal-advcomments-view-profile",
      {
        id: this.user.id(),
      }
    );
    // console.log(items.get('masquerade'));
    items.setPriority('discussions', 160);
    items.setPriority('posts', 150);

    items.add(
      "personal_advcomments",
      LinkButton.component(
        {
          href,
          icon: "far fa-comment-dots",
        },
        app.translator.trans("tolyod-advdiscus.forum.user_profile.personal_advcomments")
      ),
       140
    );

    // console.log(items);
  });
}
